import React, { useState, useEffect } from 'react'
import { CreditCard, ChevronDown, Plus, X, FileDiff } from 'lucide-react'
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import api from '../../api/api'
import { convertSingleValue } from '../../utils/commonUtils'
import {marked} from 'marked';

const graphTypes = {
  line: '折れ線グラフ',
  bar: '棒グラフ'
}

const graphData = {
  stockPrice: '株価',
  sales: '売上高',
  operatingProfit: '営業利益',
  netIncome: '当期利益',
  per: 'PER'
}

const CompanyCard = ({ onOpenCompanySidebar, companyData, widgetId }) => {
  const [graphType, setGraphType] = useState('line')
  const [graphDataType, setGraphDataType] = useState('stockPrice')
  const { selectedCompany, selectedData } = companyData[widgetId] || { selectedCompany: 'sample', selectedData: [] };
  const [fetchedData, setFetchedData] = useState({});
  const renderGraph = () => {
    const data = selectedData.graph;
    const GraphComponent = graphType === 'line' ? LineChart : BarChart;
    const DataComponent = graphType === 'line' ? Line : Bar;

    return (
      <ResponsiveContainer width="100%" height={300}>
        <GraphComponent data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <DataComponent type="linear" dataKey="value" stroke="#8884d8" fill="#8884d8" />
        </GraphComponent>
      </ResponsiveContainer>
    )
  }


  useEffect(() => {
    if (selectedData.length === 0) {
      return;
    }
    const category = selectedData[selectedData.length - 1].category;
    const fetchData = async () => {
      try {
        const response = await api.get(
            `${process.env.REACT_APP_API_URL}/chat/api/get-company-data/?secCode=${selectedCompany.secCode}&dataCategory=${category}`
        );
        setFetchedData((prev) => ({ ...prev, [category]: response.data.data })); 
      } catch (error) {
        console.error("Error fetching company data:", error);
      } finally {
      }
    };
    if (~Object.keys(fetchedData).includes(category)) {
      fetchData();
    } 
  }, [selectedCompany, selectedData])

  if (!selectedData) {
    return <></>
  }
  
  return (
    <div className="p-4 w-full min-w-[400px]">
      <button className="flex justify-between items-center">
        <h4 className="text-lg font-semibold">{selectedCompany.companyName}  {selectedCompany.companyName && "(" + selectedCompany.secCode + ")"}</h4>
      </button>
      <div className="p-2 rounded mb-4 text-lg" onClick={() => onOpenCompanySidebar(widgetId)}>
        {selectedData.map(field => (
          <div key={field.id} className="mt-2">
            {field.category === 'financial_results' ? (
              <div className="flex justify-betweentext-sm text-gray-600">
                <span className='text-gray-500 mr-2'>{field.name}</span><span className='font-bold text-gray-700'>{fetchedData[field.category] && convertSingleValue(fetchedData[field.category][field.id])}円</span>
              </div>
            ) : field === 'graph' ? (
              <div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">グラフ</span>
                </div>
                <div className="mt-2 space-y-2">
                  <div className="flex space-x-2">
                    <select
                      className="appearance-none bg-white border border-gray-300 rounded px-2 py-1 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={graphType}
                      onChange={(e) => setGraphType(e.target.value)}
                    >
                      {Object.entries(graphTypes).map(([key, value]) => (
                        <option key={key} value={key}>{value}</option>
                      ))}
                    </select>
                    <select
                      className="appearance-none bg-white border border-gray-300 rounded px-2 py-1 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={graphDataType}
                      onChange={(e) => setGraphDataType(e.target.value)}
                    >
                      {Object.entries(graphData).map(([key, value]) => (
                        <option key={key} value={key}>{value}</option>
                      ))}
                    </select>
                  </div>
                  {renderGraph()}
                </div>
              </div>
            ) : field.id === 'company_description' ? (
              <div className="flex justify-between items-center text-sm text-gray-800 bg-gray-100 p-3 rounded-md">
                {fetchedData[field.category] && <span dangerouslySetInnerHTML={{ __html: marked(fetchedData[field.category][field.id]) }}></span>}
              </div>
            ): (
              <div className="flex justify-between items-center text-lg text-gray-600">
                <span className='text-gray-500 font-bold'>{field.name}</span> <span>{fetchedData[field.category] && fetchedData[field.category][field.id]}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default CompanyCard

